import Layout from "@/components/layout/Layout";
import React from "react";
import Sidepanel from "@/components/layout/Sidepanel";
import Content from "@/components/layout/Content";
import ChoicesScreen from "@/components/screens/Choices";
import ContentOptions from "@/components/layout/ContentOptions";

/**
 * Choice Component
 * 
 * Displays a selection interface for product choices or options.
 * This appears to be an initial choice screen in the product configuration
 * workflow, likely for selecting product types or categories.
 * 
 * @param {Object} props - Component props
 * @param {Array} props.choices - Available choices/options to display
 * @param {string} props.heading - Page heading text
 * @param {Object} props.session - Current session information
 * @param {string} props.shoppingurl - URL for shopping cart navigation
 * @param {Object} props.product - Current product context (if any)
 * 
 * @returns {JSX.Element} The rendered choice selection page
 */
export default function Choice({
    choices,
    heading,
    session,
    shoppingurl,
    product,
}) {
    return (
        <Layout>
            <Sidepanel
                choices={choices}
                shoppingurl={shoppingurl}
                session={session}
                product={product}
            />
            <Content shoppingurl={shoppingurl} session={session}>
                <ContentOptions>
                    <ChoicesScreen choices={choices} heading={heading} />
                </ContentOptions>
            </Content>
        </Layout>
    );
}
